import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[620px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20artistic%20composition%20with%20soft%20flowing%20shapes%20in%20cream%20terracotta%20and%20sand%20tones%2C%20gentle%20gradients%20suggesting%20connection%20and%20harmony%2C%20minimalist%20elegant%20design%20with%20organic%20textures%2C%20calm%20and%20soothing%20atmosphere%2C%20no%20people%2C%20abstract%20art%20style%20with%20warm%20color%20palette&width=1800&height=900&seq=hero-main-bg&orientation=landscape"
          alt="家庭关系"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <p className="text-white/70 text-sm md:text-base tracking-widest mb-4 uppercase">
            {t('common.siteSubtitle')}
          </p>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            {t('home.heroTitle')}
          </h1>
          <p className="text-white/80 text-base md:text-lg leading-relaxed max-w-xl mx-auto mb-8">
            {t('home.heroDescription')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#featured"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white px-8 py-3 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              开始阅读
              <i className="ri-arrow-down-line"></i>
            </a>
            <a
              href="#categories"
              className="inline-flex items-center gap-2 bg-white/15 hover:bg-white/25 text-white px-8 py-3 rounded-full text-sm font-medium backdrop-blur-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              探索分类
              <i className="ri-compass-3-line"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <a href="#featured" className="text-white/50 hover:text-white/80 transition-colors cursor-pointer">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}